import CityPageTemplate from "../city-template/CityPageTemplate";
import { goldenConfig } from "./data";

export default function GoldenPage() {
  return <CityPageTemplate config={goldenConfig} />;
}